import { Bundle } from '@spiffcommerce/core'
import classNames from 'classnames'
import { useAppContext } from '../../context/AppContext'
import { formatCentsToDollars } from '../../helpers/formatCentsToDollars'

export const TitleBar = ({
  bundle,
  baseProductName,
  isLoading,
  className
}: {
  bundle: Bundle
  baseProductName: string
  isLoading: boolean
  className: string
}) => {
  const { isPendantQuantityScene, isPendantScene } = useAppContext()

  return (
    <div id="builder-title-bar" className={classNames('bg-background-light justify-between items-center p-[15px] md:p-5 md:h-[62px] uppercase', className)}>
      <p className="h5">{baseProductName}</p>
      {!isLoading && (
        <span>
          {!isPendantQuantityScene && !isPendantScene && 'From '}
          {formatCentsToDollars(bundle.getTotalSubunits())}
        </span>
      )}
    </div>
  )
}
